// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a252ebeee69ec510d2ff","139":"0aa1a7f7b30cb0b0b223","409":"972e04b3346d494811bc","825":"39110d5c95bfa21aa9f0"}[chunkId] + ".chunk.js";
};